
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","viewBox":"0 0 26 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"26","height":"4","rx":"2","fill":"#47AEA6"}}),_c('rect',{attrs:{"x":"3","y":"8","width":"20","height":"4","rx":"2","fill":"#47AEA6"}}),_c('rect',{attrs:{"y":"16","width":"26","height":"4","rx":"2","fill":"#47AEA6"}})])
          )
        }
      }
    